import React, { useEffect, useState } from 'react';
// import { OrderContext } from '../../context/OrderContext.js';
import "./OrderDetails.css";
import { useImage } from "../../context/ImageContext.js";
import Loader from '../Loader.js';
import Pagination from '../pagination/Pagination.js';
import { FaShoppingBag, FaCalendarAlt, FaUser, FaMapMarkerAlt, FaLiraSign, FaBox, FaStore, FaHistory, FaCreditCard, FaUniversity } from 'react-icons/fa';
import { 
  useGetOrdersQuery, 
  getOrderStatusMessage, 
  getOrderStatusClass 
} from '../../services/userApi.js';

const OrderDetails = () => {
  const { getImageUrl } = useImage();
  // const { orders, loading, error, fetchOrders, getOrderStatusMessage, getOrderStatusClass } = useContext(OrderContext);

  const { data: ordersData, isLoading, isError, error, refetch } = useGetOrdersQuery();
  const orders = ordersData || []; 

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const ordersPerPage = 5;
  
  // useEffect(() => {
  //   // fetchOrders();
  // }, []); 
  
  if (isLoading) return <Loader size={40} />;

  if (isError) {
    if (error && error.status === 401) {
      return (
        <div className="empty-state">
          <div className="empty-icon">
            <FaShoppingBag />
          </div>
          <h3>Henüz siparişiniz bulunmamaktadır</h3>
          <p>Yaptığınız siparişler burada listelenecektir</p>
        </div>
      );
    } 
    let errorMessage = "Siparişler yüklenirken bir hata oluştu";
    if (error && error.data && error.data.message) {
      errorMessage = error.data.message;
    } else if (error && error.message) {
      errorMessage = error.message;
    }

    return (
      <div className="error-state">
        <h3>{errorMessage}</h3>
        <p>Lütfen daha sonra tekrar deneyiniz veya destek ile iletişime geçiniz.</p>
      </div>
    );
  }

  // Sayfalama hesaplamaları
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders ? orders.slice(indexOfFirstOrder, indexOfLastOrder) : [];
  const totalPages = orders ? Math.ceil(orders.length / ordersPerPage) : 0;
  
  const formatDate = (dateString) => {
    try {
      const orderDate = new Date(dateString);
      if (isNaN(orderDate.getTime()) || orderDate.getFullYear() < 2000) {
        console.warn("Formatlanacak geçersiz tarih:", dateString);
        return "Tarih bilgisi mevcut değil";
      }
      return orderDate.toLocaleDateString('tr-TR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      console.error("Tarih dönüştürme hatası:", error);
      return "Tarih bilgisi mevcut değil";
    }
  };

  const toggleOrderDetails = (orderId) => {
    if (selectedOrder === orderId) {
      setSelectedOrder(null);
    } else {
      setSelectedOrder(orderId);
    }
  };

  return (
    <div className="orders-container">
      {!isLoading && !isError && orders && orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            <FaShoppingBag />
          </div>
          <h3>Henüz siparişiniz bulunmamaktadır</h3>
          <p>Yaptığınız siparişler burada listelenecektir</p>
        </div>
      ) : (
        <>
          <div className="orders-list">
            {currentOrders.map((order) => (
              <div key={order.id} className="order-card">
                <div className="profile-order-summary" onClick={() => toggleOrderDetails(order.id)}>
                  <div className="order-header">
                    <div className="order-date">
                      <FaCalendarAlt className="order-icon" />
                      <span>{formatDate(order.siparis_tarihi)}</span>
                    </div>
                    <div className="order-price">
                      <FaLiraSign className="order-icon" />
                      <span>{parseFloat(order.toplam_tutar).toFixed(2)} TL</span>
                    </div>
                  </div>
                  
                  <div className="order-meta">
                    <div className="meta-item">
                      <FaUser className="meta-icon" />
                      <span>Alıcı: {order.ad} {order.soyad}</span>
                    </div>
                    <div className="meta-item">
                      <FaMapMarkerAlt className="meta-icon" />
                      <span>Adres: {order.adres}</span>
                    </div>
                    <div className="meta-item">
                      {order.odeme_yontemi === 4 ? (
                        <FaUniversity className="meta-icon" />
                      ) : (
                        <FaCreditCard className="meta-icon" />
                      )}
                      <span>Ödeme: {order.odeme_yontemi === 4 ? 'EFT' : 'Kredi Kartı'}</span>
                    </div>
                  </div>
                  
                  <div className="expand-indicator">
                    <span>{selectedOrder === order.id ? "Detayları Gizle" : "Detayları Göster"}</span>
                  </div>
                </div>

                {selectedOrder === order.id && (
                  <div className="profile-order-details">
                    {order.products && order.products.length > 0 ? (                      
                      <>
                        <h4 className="details-title">
                          <FaBox className="details-icon" />
                          Sipariş Ürünleri
                        </h4>
                        
                        <div className="products-table">
                          <table>
                            <thead>
                              <tr>
                                <th>Ürün</th>
                                <th>Ürün Adı</th>
                                <th>Adet</th>
                                <th>Fiyat</th>
                                <th>Mağaza</th>
                                <th>Durum</th>
                              </tr>
                            </thead>
                            <tbody>
                              {order.products.map((product, index) => (                                
                                <tr key={index}>
                                  <td className="product-image">
                                    <img src={getImageUrl(product.resim.i1)} alt={product.baslik} />
                                  </td>
                                  <td className="product-title">{product.baslik}</td>
                                  <td className="product-quantity">{product.quantity || 1}</td>
                                  <td className="product-price">{parseFloat(product.fiyat).toFixed(2)} TL</td>
                                  <td className="product-store">{product.magaza_adi}</td>
                                  <td className={`product-status status-${getOrderStatusClass(order.durum, order.odeme_yontemi)}`}>
                                    {getOrderStatusMessage(order.durum, order.odeme_yontemi)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        
                        <div className="products-mobile">
                          {order.products.map((product, index) => (
                            <div key={index} className="product-mobile-card">
                              <div className="product-mobile-header">
                                <img src={getImageUrl(product.resim.i1)} alt={product.baslik} />
                                <div className="product-mobile-title">{product.baslik}</div>
                              </div>
                              
                              <div className="product-mobile-body">
                                <div className="mobile-info-row">
                                  <div className="mobile-info-item">
                                    <span className="info-label">Adet:</span>
                                    <span className="info-value">{product.quantity || 1}</span>
                                  </div>
                                  <div className="mobile-info-item">
                                    <span className="info-label">Fiyat:</span>
                                    <span className="info-value">{parseFloat(product.fiyat).toFixed(2)} TL</span>
                                  </div>
                                </div>
                                
                                <div className="mobile-info-row">
                                  <div className="mobile-info-item">
                                    <span className="info-label">
                                      <FaStore className="info-icon" /> Mağaza:
                                    </span>
                                    <span className="info-value">{product.magaza_adi}</span>
                                  </div>
                                </div>
                                
                                <div className="mobile-status-row">
                                  <span className="info-label">
                                    <FaHistory className="info-icon" /> Durum:
                                  </span>
                                  <span className={`mobile-status status-${getOrderStatusClass(order.durum, order.odeme_yontemi)}`}>
                                    {getOrderStatusMessage(order.durum, order.odeme_yontemi)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div className="no-products">
                        <p>Ürün bilgisi bulunamadı.</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
          
          {totalPages > 1 && (
            <div className="pagination-wrapper">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default OrderDetails;
